import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SettingsLayout } from '../../components/Pleri/components/Settings/SettingsLayout';
import { OrganizationUsagePage } from '../../components/Pleri/components/Settings/OrganizationUsagePage';
import { ProtectedComponent } from '../../components/ProtectedComponent/ProtectedComponent';
import { useUserProfile } from '../../api/profile';
import { isPermitted } from '@plerionhq/design-system';

import { useTranslation } from 'react-i18next';

const USAGE_PERMISSION = ['pleri:OrgUsage', 'pleri:Write'];

export const Route = createFileRoute('/settings/organization-usage')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation('pleri/pages');
  const { data: userProfile } = useUserProfile();
  const permissions = userProfile?.permissions || [];
  const hasPermission = isPermitted(permissions, USAGE_PERMISSION, false);

  return (
    <SettingsLayout>
      <ProtectedComponent permission={USAGE_PERMISSION}>
        <OrganizationUsagePage />
      </ProtectedComponent>
      {!hasPermission && (
        <div className="flex h-full items-center justify-center p-8">
          <div className="text-center">
            <p className="text-lg font-medium text-gray-900 dark:text-gray-100">
              {t('accessDenied')}
            </p>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {t('youDonHavePermissionOrgAdminRequired')}
            </p>
          </div>
        </div>
      )}
    </SettingsLayout>
  );
}
